enum FormMode {
  Edit = 'Edit',
  Preview = 'Preview',
}

export { FormMode };
